import Network from '@/services/network'

export default function () {
    const network = new Network;

    const fetchPendingAssetRegister = (query) => {
        return network.api('get', '/asset-register/pending-asset-register' + query);
    }

    const fetchSinglePendingAssetRegister = (assetRegisterId, query) => {
        return network.api('get', '/asset-register/pending-asset-register/' + assetRegisterId + query);
    }

    const fetchAssetRegister = (query) => {
        return network.api('get', '/asset-register/asset-register' + query);
    }

    const storeAssetRegister = (data, query) => {
        return network.api('post', '/asset-register/asset-register'+query, data);
    }

    const fetchSingleAssetRegister = (assetRegisterId, query) => {
        return network.api('get', '/asset-register/asset-register/' + assetRegisterId + query);
    }

    const updateAssetRegister = (data, assetRegisterId, query) => {
        return network.api('put', '/asset-register/asset-register/'+ assetRegisterId + query, data);
    }

    return {
        fetchPendingAssetRegister,
        fetchSinglePendingAssetRegister,
        storeAssetRegister,
        fetchAssetRegister,
        fetchSingleAssetRegister,
        updateAssetRegister
    }
}